import { Suspense, type ReactNode } from 'react';
import { Loading } from '../ui/feedback.js';

/**
 * Chargement des écrans de l'espace garage. Depuis la vague 5, la session, le garage de l'adresse
 * (`/g/:slug/`) et le contexte utilisateur sont résolus par `GarageSpace` (shared/layout.tsx) ; les
 * pages n'ont plus qu'à attendre le code de leur écran.
 */
export function GarageGate({ children }: { children: ReactNode }) {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
}
